import React from 'react';
import moment from 'moment';
import {makeStyles} from "@material-ui/core";
import {tableStyle} from "../../UIComponent/CommonStyle";

export function setReqApprovalColumns(approveIconRender, showStaffNo, intl) {
    const useStyles = makeStyles((theme) => ({
        ...tableStyle(theme),
        vertical: {
            overflow: "hidden",
            display: "-webkit-box",
            whiteSpace: "pre-line",
            WebkitBoxOrient: "vertical",
        },
    }));

    const classes = useStyles();
    return [
        {
            name: 'id',
            label: 'ID',
            options: {
                filter: false,
                sort: true,
                display: false,
            },
        },
        {
            name: 'staffNo',
            label: intl.formatMessage({ id: 'leave_approval.staff_number' }),
            options: {
                filter: true,
                sort: true,
                filterType: 'textField',
                display: showStaffNo,
            },
        },
        {
            name: 'employee',
            label: intl.formatMessage({ id: 'leave_approval.employee' }),
            options: {
                filter: true,
                sort: true,
                filterType: 'textField',
            },
        },
        {
            name: 'position',
            label: intl.formatMessage({ id: 'leave_approval.position' }),
            options: {
                filter: true,
                sort: true,
                filterType: 'textField',
            },
        },
        {
            name: 'location',
            label: intl.formatMessage({ id: 'leave_approval.location' }),
            options: {
                filter: true,
                sort: true,
            },
        },
        {
            name: 'items',
            label: intl.formatMessage({ id: 'comp_leave.items' }),
            options: {
                filter: false,
                sort: true,
            },
        },
        {
            name: 'justification',
            label: intl.formatMessage({ id: 'comp_leave.justification' }),
            options: {
                filter: false,
                sort: true,
                setCellProps: () => ({
                    style: {
                        height: 'auto',
                    }
                }),
                customBodyRender: (value) => {
                    return (
                        <div className={classes.vertical}>
                            {value}
                        </div>
                    );
                }
            }
        },
        {
            name: 'period',
            label: intl.formatMessage({ id: 'comp_leave.period' }),
            options: {
                filter: false,
                sort: true,
                setCellProps: (value) => {
                    const minWidth = `${value.props.children.length * 2.66}px`;
                    return {
                        style: {
                            minWidth: minWidth,
                            height: 'auto',
                            whiteSpace: 'nowrap'
                        }
                    };
                },
                customBodyRender: (value) => {
                    return (
                        <div className={classes.vertical}>
                            {value}
                        </div>
                    );
                }
            },
        },
        {
            name: 'totalHours',
            label: intl.formatMessage({ id: 'comp_leave.hours' }),
            options: {
                filter: false,
                sort: true,
            },
        },
        {
            name: 'dataSubmitted',
            label: intl.formatMessage({ id: 'table.date_submitted' }),
            options: {
                filter: false,
                sort: true,
                display: false,
            },
        },
        {
            name: 'approve',
            label: intl.formatMessage({ id: 'leave_approval.approval' }),
            options: {
                filter: false,
                sort: true,
                empty: true,
                customBodyRender: approveIconRender,
            },
        },
    ];
}

export function setReqApprovalOptions(
    selectItem,
    showSelectBox,
    customToolbar,
    handleOpen,
    customToolbarSelect,
    intl,
    rowsPerPage
) {
    return {
        filterType: 'checkbox',
        elevation: 1,
        download: false,
        print: false,
        search: false,
        rowsSelected: selectItem,
        selectableRows: showSelectBox,
        customToolbar: customToolbar,
        onRowClick: (rowData, rowMeta) => {
            handleOpen(rowData[0]);
        },
        customToolbarSelect: customToolbarSelect,
        textLabels: textLabels(intl),
        rowsPerPage: rowsPerPage,
        rowsPerPageOptions: [rowsPerPage]
    };
}

export function setReqApprovalHistoryColumns(showStaffNo, intl, showApproveRejectOnly) {
    return [
        {
            name: 'id',
            label: 'ID',
            options: {
                filter: false,
                sort: true,
                display: false,
            },
        },
        {
            name: 'staffNo',
            label: intl.formatMessage({ id: 'leave_approval.staff_number' }),
            options: {
                filter: true,
                sort: true,
                filterType: 'textField',
            },
        },
        {
            name: 'employee',
            label: intl.formatMessage({ id: 'leave_approval.employee' }),
            options: {
                filter: true,
                sort: true,
                filterType: 'textField',
            },
        },
        {
            name: 'position',
            label: intl.formatMessage({ id: 'leave_approval.position' }),
            options: {
                filter: true,
                sort: true,
                filterType: 'textField',
            },
        },
        {
            name: 'location',
            label: intl.formatMessage({ id: 'leave_approval.location' }),
            options: {
                filter: true,
                sort: true,
            },
        },
        {
            name: 'department',
            label: intl.formatMessage({ id: 'leave_approval.department' }),
            options: {
                filter: false,
                sort: false,
                display: false,
            },
        },
        {
            name: 'period',
            label: intl.formatMessage({ id: 'comp_leave.period' }),
            options: {
                filter: false,
                sort: true,
            },
        },
        {
            name: 'totalHours',
            label: intl.formatMessage({ id: 'comp_leave.hours' }),
            options: {
                filter: false,
                sort: true,
            },
        },
        {
            name: 'dateSubmitted',
            label: intl.formatMessage({ id: 'table.date_submitted' }),
            options: {
                filter: false,
                sort: true,
            },
        },
        {
            name: 'dateApproved',
            label: showApproveRejectOnly
                ? intl.formatMessage({ id: 'table.date_approved' })
                : intl.formatMessage({ id: 'table.last_updated' }),
            options: {
                filter: false,
                sort: true,
            },
        },
        {
            name: 'status',
            label: intl.formatMessage({ id: 'table.status' }),
            options: {
                filter: true,
                sort: true,
                ...(showApproveRejectOnly && {
                    filterList: [intl.formatMessage({ id: 'status.2' })]
                }),
            },
        },
    ];
}

export function setReqApprovalHistoryOptions(intl) {
    return {
        elevation: 1,
        download: false,
        print: false,
        search: false,
        selectableRows: 'none',
        downloadOptions: {
            filename: 'CompLeaveReqApprovalRecord' + getCurrentDate() + '.csv',
            separator: ',',
        },
        textLabels: textLabels(intl),
    };
}

function textLabels(intl) {
    return {
        body: {
            noMatch: intl.formatMessage({ id: 'table.no_match' }),
            toolTip: intl.formatMessage({ id: 'table.sort' }),
            columnHeaderTooltip: (column) =>
                intl.formatMessage({ id: 'table.sort_for' }) +
                ` ${column.label}`,
        },
        viewColumns: {
            title: intl.formatMessage({ id: 'table.show_columns' }),
            titleAria: intl.formatMessage({
                id: 'table.show_hide_table_columns',
            }),
        },
        selectedRows: {
            text: intl.formatMessage({ id: 'table.rows_selected' }),
            delete: 'Delete',
            deleteAria: 'Delete Selected Rows',
        },
        toolbar: {
            search: intl.formatMessage({ id: 'table.search' }),
            downloadCsv: intl.formatMessage({ id: 'table.downloadCsv' }),
            print: intl.formatMessage({ id: 'table.print' }),
            viewColumns: intl.formatMessage({ id: 'table.viewColumns' }),
            filterTable: intl.formatMessage({ id: 'table.filterTable' }),
        },
        filter: {
            all: intl.formatMessage({ id: 'table.all' }),
            title: intl.formatMessage({ id: 'table.filters' }),
            reset: intl.formatMessage({ id: 'table.reset' }),
        },
        pagination: {
            next: intl.formatMessage({ id: 'table.next' }),
            previous: intl.formatMessage({ id: 'table.previous' }),
            rowsPerPage: intl.formatMessage({ id: 'table.rowsPerPage' }),
            displayRows: intl.formatMessage({ id: 'table.displayRows' }),
        },
    };
}

function getCurrentDate() {
    const newDate = new Date();
    return moment(newDate).format('_YYYY/MM/DD');
}
